import { createSlice } from "@reduxjs/toolkit";
import {
  getTicketForFallback,
  refreshApplicationResultForFallback,
  updateTicketDeadlineForFallback,
  updateTicketForFallback,
} from "./Thunk";

export const ticketEditor = createSlice({
  name: "ticketEditor",
  initialState: {
    id: "",
    name: "",
    fetchedTicket: null,
    isLoading: false,
  },
  reducers: {
    UpdateCompanyId(state, action) {
      state.companyId = action.payload.companyId;
    },

    ChangeIsUpdateOperation(state, action) {
      state.isUpdateOperation = action.payload.isUpdateOperation;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getTicketForFallback.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getTicketForFallback.fulfilled, (state, action) => {
      state.fetchedTicket = action.payload;

      state.isLoading = false;
    });
    builder.addCase(updateTicketForFallback.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(updateTicketForFallback.fulfilled, (state, action) => {
      state.isLoading = false;
    });

    builder.addCase(updateTicketDeadlineForFallback.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(updateTicketDeadlineForFallback.fulfilled, (state, action) => {
      state.isLoading = false;
    });

    builder.addCase(refreshApplicationResultForFallback.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(refreshApplicationResultForFallback.fulfilled, (state, action) => {
      state.isLoading = false;
    });
  },
});

export const { SetUpdatePositionModalData, ShowUpdatePositionModal } = ticketEditor.actions;

export default ticketEditor.reducer;
